import React, { useState, useEffect } from 'react';
import './create-doctor.css';
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from '../config.js';

export default function CreateAccountDoctor() {
  const [step, setStep] = useState(1);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [successMsg, setSuccessMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const specialties = [
    "طب عام",
    "طب الأسرة",
    "طب أطفال",
    "أمراض القلب",
    "طب العيون",
    "طب النساء والولادة",
    "طب الأنف والأذن والحنجرة",
    "طب الجلدية",
    "طب الأعصاب",
    "طب النفس",
    "طب العظام",
    "طب الطوارئ",
    "طب الأشعة",
    "طب الجراحة",
    "أمراض الجهاز الهضمي",
    "طب المسالك البولية",
    "أمراض الكلى",
    "أمراض الدم",
    "الأمراض الصدرية",
    "الأمراض المعدية",
    "طب الأورام",
    "جراحة قلبية",
    "جراحة عظمية",
    "جراحة عصبية",
    "جراحة تجميلية",
    "جراحة عامة",
    "أشعة",
    "مخابر",
    "تخدير",
    "علاج فيزيائي",
    "علوم الأغذية",
  ];

  const governorates = [
    "دمشق",
    "حلب",
    "اللاذقية",
    "دير الزور",
    "إدلب",
    "حمص",
    "حماة",
    "درعا",
    "سويداء",
    "قنيطرة",
    "طرطوس",
    "الحسكة",
    "الرقة",
    "ريف دمشق",
  ];

  const governorates_english = [
    "Damascus",
    "Aleppo",
    "Latakia",
    "Deir ez-Zor",
    "Idlib",
    "Homs",
    "Hama",
    "Daraa",
    "Suweida",
    "Quneitra",
    "Tartus",
    "Hasakah",
    "Raqqa",
    "Rif Dimashq",
  ];

  const [allHospitals, setAllHospitals] = useState([]);
  const [filteredHospitals, setFilteredHospitals] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    username: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    specialty: "",
    city: "",
    hospital_id: "",
    address: ""
  });

  // جلب المستشفيات
  useEffect(() => {
    const fetchHospitals = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/registration-hospitals/`);
        if (response.ok) {
          const data = await response.json();
          setAllHospitals(data);
        }
      } catch (error) {
        console.error("Failed to fetch hospitals:", error);
      }
    };
    fetchHospitals();
  }, []);

  // معالج التغيير مع التحقق الفوري
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value
    });

    let newErrors = { ...errors };

    // الاسم
    if (name === "name") {
      if (!value) newErrors.name = "هذا الحقل مطلوب";
      else delete newErrors.name;
    }

    // اسم المستخدم
    if (name === "username") {
      if (!value) newErrors.username = "هذا الحقل مطلوب";
      else delete newErrors.username;
    }

    // الايميل
    if (name === "email") {
      if (!value) newErrors.email = "الايميل مطلوب";
      else if (!/\S+@\S+\.\S+/.test(value))
        newErrors.email = "الايميل غير صالح";
      else delete newErrors.email;
    }

    // رقم الهاتف
    if (name === "phone") {
      if (!value) newErrors.phone = "هذا الحقل مطلوب";
      else if (!/^\d+$/.test(value))
        newErrors.phone = "أرقام فقط";
      else delete newErrors.phone;
    }

    // كلمة المرور
    if (name === "password") {
      if (!value) {
        newErrors.password = "هذا الحقل مطلوب";
      } else if (value.length < 6) {
        newErrors.password = "يجب أن تكون 6 أحرف على الأقل";
      } else {
        delete newErrors.password;
      }
    }

    // تأكيد كلمة المرور
    if (name === "confirmPassword") {
      if (!value) {
        newErrors.confirmPassword = "هذا الحقل مطلوب";
      } else if (value !== formData.password) {
        newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
      } else {
        delete newErrors.confirmPassword;
      }
    }

    // إعادة التحقق عند تعديل password
    if (name === "password" && formData.confirmPassword) {
      if (formData.confirmPassword !== value) {
        newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
      } else {
        delete newErrors.confirmPassword;
      }
    }

    setErrors(newErrors);
  };

  // معالج تغيير المدينة
  const handleCityChange = (e) => {
    const selectedCity = e.target.value;
    setFormData({ ...formData, city: selectedCity, hospital_id: "" });

    if (!selectedCity) {
      setFilteredHospitals([]);
      return;
    }

    const filteredArabic = allHospitals.filter(h => {
      return h.city && h.city.trim().toLowerCase() === selectedCity.trim().toLowerCase();
    });

    const index = governorates.indexOf(selectedCity);
    const englishCity = index !== -1 ? governorates_english[index] : "";

    const filteredEnglish = englishCity
      ? allHospitals.filter(h => h.city && h.city.trim().toLowerCase() === englishCity.trim().toLowerCase())
      : [];

    const combinedHospitals = [...filteredArabic, ...filteredEnglish];
    const uniqueHospitals = Array.from(
      new Map(combinedHospitals.map(hospital => [hospital.id, hospital])).values()
    );

    setFilteredHospitals(uniqueHospitals);
  };

  // التحقق من صحة البيانات - الخطوة 1
  const validateStep1 = () => {
    let newErrors = {};

    if (!formData.name) {
      newErrors.name = "هذا الحقل مطلوب";
    }

    if (!formData.username) {
      newErrors.username = "هذا الحقل مطلوب";
    }

    if (!formData.email) {
      newErrors.email = "الايميل مطلوب";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "الايميل غير صالح";
    }

    if (!formData.phone) {
      newErrors.phone = "هذا الحقل مطلوب";
    } else if (!/^\d+$/.test(formData.phone)) {
      newErrors.phone = "يجب إدخال أرقام فقط";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // التحقق من صحة البيانات - الخطوة 2
  const validateStep2 = () => {
    let newErrors = {};

    if (!formData.password) {
      newErrors.password = "هذا الحقل مطلوب";
    } else if (formData.password.length < 6) {
      newErrors.password = "يجب أن تكون 6 أحرف على الأقل";
    }

    if (!formData.confirmPassword) {
      newErrors.confirmPassword = "هذا الحقل مطلوب";
    } else if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = "كلمتا المرور غير متطابقتين";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // التحقق من صحة البيانات - الخطوة 3
  const validateStep3 = () => {
    let newErrors = {};

    if (!formData.specialty) {
      newErrors.specialty = "اختر التخصص";
    }

    if (!formData.city) {
      newErrors.city = "اختر المحافظة";
    }

    if (!formData.hospital_id) {
      newErrors.hospital_id = "اختر المشفى";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // التنقل إلى الخطوة التالية
  const handleNext = () => {
    if (step === 1 && validateStep1()) {
      setStep(2);
    } else if (step === 2 && validateStep2()) {
      setStep(3);
    }
  };

  // العودة للخطوة السابقة
  const handleBack = () => {
    if (step > 1) setStep(step - 1);
  };

  // إرسال البيانات
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStep3()) return;

    setLoading(true);
    setApiError("");
    setSuccessMsg("");

    const payload = {
      username: formData.username || "",
      real_name: formData.name || "",
      email: formData.email || "",
      phon_number: formData.phone || "",
      password: formData.password || "",
      password_confirm: formData.confirmPassword || "",
      specialization: formData.specialty,
      hospital_id: parseInt(formData.hospital_id, 10)
    };

    try {
        const token = localStorage.getItem("access_token");
      const response = await fetch(`${API_BASE_URL}/users/create-account/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          real_name: formData.name,
          username: formData.username,
          email: formData.email,
          phon_number: formData.phone,
          password: formData.password,
          password_confirm: formData.confirmPassword,
          role: 'doctor',
          specialization: formData.specialty,
          hospital_id: parseInt(formData.hospital_id, 10),
          is_active: true, // تفعيل الحساب بشكل مباشر دون الحاجة لخطوات إضافية
        })
      });
      const data = await response.json();

       if (response.ok) {
            setSuccessMsg("تم إنشاء حساب الطبيب وتفعيله بنجاح!");
            setTimeout(() => {
            navigate("/all-doctors");
            }, 1500);
        }
        else {
            let errorMsg = "فشل في إنشاء الحساب، يرجى التحقق من البيانات المطلوبة.";
            if (typeof data === 'object') {
                errorMsg = Object.entries(data)
                    .map(([key, val]) => {
                // ترجمة بعض المفاتيح لتبدو احترافية للمستخدم
                        const keyMap = {
                            username: "اسم المستخدم",
                            email: "البريد الإلكتروني",
                            phon_number: "رقم الهاتف",
                            password: "كلمة المرور",
                            non_field_errors: "خطأ"
                        };
                        const fieldName = keyMap[key] ? keyMap[key] + ': ' : (key === 'non_field_errors' ? '' : key + ': ');
                        const messages = Array.isArray(val) ? val.join(' ') : val;
                        return `${fieldName}${messages}`;
                })
            .join(' | ');
        }
        setApiError(errorMsg);
      }
    } catch (err) {
      setApiError("تعذر الاتصال بالخادم. يرجى التحقق من اتصالك بالإنترنت والمحاولة لاحقاً.");
    } finally {
      setLoading(false);
    }
  };
  // دالة عرض شريط التقدم (من اليمين إلى اليسار)
  const renderStepper = () => {
    const steps = [
      { number: 1, label: 'المعلومات الشخصية' },
      { number: 2, label: 'كلمة المرور' },
      { number: 3, label: 'المعلومات المهنية' }
    ];

    return (
      <div className="create-account-stepper">
        {steps.map((s, index) => (
          <React.Fragment key={s.number}>
            <div className="stepper-item">
              <div 
                className={`stepper-circle ${
                  step === s.number ? 'active' : 
                  step > s.number ? 'completed' : ''
                }`}
              >
                {s.number}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div className={`stepper-line ${step > s.number ? 'active' : ''}`}></div>
            )}
          </React.Fragment>
        ))}
      </div>
    );
  };

  return (
    <div className="create-account-doctor-container" dir="ltr">
      <div className="create-account-doctor-left">
        <form className="create-account-doctor-form">
          <h3 className="create-account-doctor-h3">إنشاء حساب طبيب</h3>

          {/* شريط التقدم من اليمين إلى اليسار */}
          {renderStepper()}

          {apiError && (
            <div className="error-text" style={{ textAlign: "center", marginBottom: "10px", width: "100%", fontSize: "13px" }}>
              {apiError}
            </div>
          )}

          {/* الخطوة 1: المعلومات الشخصية */}
          {step === 1 && (
            <>
              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-user"></i>
                <input
                  type="text"
                  placeholder="الاسم"
                  onChange={handleChange}
                  name="name"
                  value={formData.name}
                  className={errors.name ? "input error" : "input"}
                />
                {errors.name && <span className="error-text">{errors.name}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-circle-user"></i>
                <input
                  type="text"
                  placeholder="اسم المستخدم"
                  onChange={handleChange}
                  name="username"
                  value={formData.username}
                  className={errors.username ? "input error" : "input"}
                />
                {errors.username && <span className="error-text">{errors.username}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-at"></i>
                <input
                  type="email"
                  placeholder="البريد الإلكتروني"
                  onChange={handleChange}
                  name="email"
                  value={formData.email}
                  className={errors.email ? "input error" : "input"}
                />
                {errors.email && <span className="error-text">{errors.email}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-phone"></i>
                <input
                  type="tel"
                  placeholder="رقم الهاتف"
                  onChange={handleChange}
                  name="phone"
                  value={formData.phone}
                  className={errors.phone ? "input error" : "input"}
                />
                {errors.phone && <span className="error-text">{errors.phone}</span>}
              </div>

              <button
                className="create-account-doctor-submit"
                type="button"
                onClick={handleNext}
              >
                متابعة
              </button>
            </>
          )}

          {/* الخطوة 2: كلمة المرور */}
          {step === 2 && (
            <>
              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-unlock"></i>
                <input
                  type="password"
                  autoComplete="new-password"
                  placeholder="كلمة المرور"
                  onChange={handleChange}
                  name="password"
                  value={formData.password}
                  className={errors.password ? "input error" : "input"}
                />
                {errors.password && <span className="error-text">{errors.password}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-lock"></i>
                <input
                  type="password"
                  autoComplete="new-password"
                  placeholder="تأكيد كلمة المرور"
                  onChange={handleChange}
                  name="confirmPassword"
                  value={formData.confirmPassword}
                  className={errors.confirmPassword ? "input error" : "input"}
                />
                {errors.confirmPassword && <span className="error-text">{errors.confirmPassword}</span>}
              </div>

              <div className="buttons-container">
                <button
                  className="create-account-doctor-submit btn-back"
                  type="button"
                  onClick={handleBack}
                >
                  السابق
                </button>
                <button
                  className="create-account-doctor-submit"
                  type="button"
                  onClick={handleNext}
                >
                  متابعة
                </button>
              </div>
            </>
          )}

          {/* الخطوة 3: معلومات المهنة */}
          {step === 3 && (
            <>
              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-stethoscope"></i>
                <select
                  value={formData.specialty}
                  onChange={(e) => setFormData({ ...formData, specialty: e.target.value })}
                  className={errors.specialty ? "input error" : "input"}
                  disabled={loading}
                >
                  <option value="">اختر التخصص</option>
                  {specialties.map((s, i) => (
                    <option key={i} value={s}>{s}</option>
                  ))}
                </select>
                {errors.specialty && <span className="error-text">{errors.specialty}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-city"></i>
                <select
                  value={formData.city}
                  onChange={handleCityChange}
                  className={errors.city ? "input error" : "input"}
                  disabled={loading}
                >
                  <option value="">اختر المحافظة</option>
                  {governorates.map((g, i) => (
                    <option key={i} value={g}>{g}</option>
                  ))}
                </select>
                {errors.city && <span className="error-text">{errors.city}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-hospital"></i>
                <select
                  value={formData.hospital_id}
                  onChange={(e) => setFormData({ ...formData, hospital_id: e.target.value })}
                  className={errors.hospital_id ? "input error" : "input"}
                  disabled={loading}
                >
                  <option value="">اختر المشفى</option>
                  {filteredHospitals.map((h) => (
                    <option key={h.id} value={h.id}>
                      {h.name}
                    </option>
                  ))}
                </select>
                {errors.hospital_id && <span className="error-text">{errors.hospital_id}</span>}
              </div>

              <div className="create-account-doctor-input-group">
                <i className="fa-solid fa-location-dot"></i>
                <input
                  type="text"
                  placeholder="عنوان المشفى"
                  value={formData.address}
                  onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  disabled={loading}
                />
              </div>

              <div className="buttons-container">
                <button
                  className="create-account-doctor-submit btn-back"
                  type="button"
                  onClick={handleBack}
                  disabled={loading}
                >
                  السابق
                </button>
                <button
                  type="button"
                  className="create-account-doctor-submit"
                  onClick={handleSubmit}
                  disabled={
                    loading ||
                    !formData.specialty ||
                    !formData.city ||
                    !formData.hospital_id
                  }
                >
                  {loading ? "جاري إنشاء الحساب وإرسال الرمز..." : "إنشاء حساب"}
                </button>
              </div>
            </>
          )}
        </form>
      </div>

      <div className="create-account-doctor-right">
        <img
          className='syria-logo-create-account-doctor-logo'
          src="../images/Emblem_of_Syria_(2025–present).svg.png"
          alt="شعار الجمهورية"
        />
        <h1 className="create-account-doctor-title">الجمهورية العربية السورية</h1>
        <h4 className="create-account-doctor-sub">وزارة الصحة - منصة التنبؤ بالأوبئة</h4>
      </div>
    </div>
  );
}